import { Injectable } from "@angular/core";
import { WebsocketService } from "@app/shared/databases/websocket";
import { DataServiceError } from "@app/shared/services/data-service-error";
import { DbCrudHelper } from "@app/shared/services/db-crud-helper";
import { Observable, catchError, map } from "rxjs";
import { EntityAncestor } from "../model/entity";

@Injectable({
    providedIn: "root",
})
export class EntityTreeDbService {
    crudHelper = new DbCrudHelper(this.websocketService);

    constructor(private websocketService: WebsocketService) {}

    /**
     * @description Fetches an entity ancestor from the database
     * @param entityId the ID of the entity to fetch
     * @returns {Observable<EntityAncestor>} the entity with its ancestor
     */
    getEntityAncestor(entityId: number): Observable<EntityAncestor> {
        return this.crudHelper.makeRequest<number[]>("GetEntityAncestors", { id: entityId }).pipe(
            map(ids => EntityAncestor.fromDbObject(ids)),
            catchError(DataServiceError.handleError())
        );
    }
}
